export const SET_IMAGE_URL_WIDGET_THIS_IS_ME = 'SET_IMAGE_URL_WIDGET_THIS_IS_ME'

interface SetImageUrlWidgetAction {
  type: typeof SET_IMAGE_URL_WIDGET_THIS_IS_ME
  url: string
}

export const setImageUrlWidgetAction = (url: string) => ({
  type: SET_IMAGE_URL_WIDGET_THIS_IS_ME,
  url,
})

export const TOGGLE_UPDATE_FOREIGN_PROFILE =
  'TOGGLE_UPDATE_FOREIGN_PROFILE' as const

export const toggleUpdateForeignProfileAction = (value: boolean) => ({
  type: TOGGLE_UPDATE_FOREIGN_PROFILE,
  value,
})

export type ForeignProfileHitTypes =
  | SetImageUrlWidgetAction
  | ReturnType<typeof toggleUpdateForeignProfileAction>
